import { resumeEverything } from './api';
import { ask } from './ask';
import { labels } from './labels';

/**
 * The one Resume flow, for the Pipeline status card (`PauseEverythingControl.tsx`): the confirm dialog, then the write through
 * the caller's `useActionError().run`. Returns `true` when the pipeline resumed. The backend
 * records the signed-in user as the one who resumed (QA-31).
 */
export async function confirmResumeEverything(run: (write: () => Promise<unknown>) => Promise<boolean>): Promise<boolean> {
  const answers = await ask({
    ...labels.pauseEverything.resumeConfirm,
    confirmLabel: labels.pauseEverything.resumeButton,
  });
  if (!answers) return false;
  return run(() => resumeEverything());
}
